<!-- Body Content-->
<div class="md:pt-3 pt-2 md:px-4 px-3 pb-8 mb-6">
  <h1 class="text-base md:text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1" data-testid="create-campaign-header">
    {{'CAMPAIGN.NEW_ANIMATION' | translate }}
    <i class="fa fa-circle-question text-xl text-600 cursor-pointer ml-2"
      pTooltip="This is a sample!"
      tooltipStyleClass="text-xs"
      aria-label="campaign-help-tooltip"
    data-testid="campaign-help-tooltip"></i>
  </h1>
  <div class="mt-1 mb-3">
    <app-breadcrumb />
  </div>

  <form [formGroup]="createCampaignForm">
    <!-- Basic Info Card -->
    <div class="surface-0 shadow-2 border-round p-3 text-sm mt-3 relative">
      <!-- Campaign Name -->
      <div class="mb-3">
        <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-name-label">{{'SEND_EMAIL.CAMPAIGN_NAME' | translate }}</label>
        <input type="text"
          formControlName="campaign_name"
          class="text-sm w-full"
          pInputText
          [placeholder]="'SEND_EMAIL.NAME_PLACEHOLDER' | translate"
          [ngClass]="{ 'ng-invalid ng-dirty': CampaignNameFormControl.invalid && CampaignNameFormControl.touched }"
          aria-label="campaign-name-input"
          data-testid="campaign-name-input" />
          @if (CampaignNameFormControl.touched && CampaignNameFormControl.invalid) {
            <app-error-msg [errors]="CampaignNameFormControl.errors"
              [fieldLabel]="'SEND_EMAIL.CAMPAIGN_NAME_ERROR' | translate"
              data-testid="campaign-name-error" />
          }
        </div>

        <!-- Campaign Description -->
        <div class="mb-3">
          <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-description-label">{{'SEND_EMAIL.CAMPAIGN_DESCRIPTION' | translate }}</label>
          <textarea pTextarea
            formControlName="campaign_description"
            class="w-full h-4rem"
            [placeholder]="'SEND_EMAIL.DESC_PLACEHOLDER' | translate"
            [ngClass]="{ 'ng-invalid ng-dirty': CampaignDescriptionFormControl.invalid && CampaignDescriptionFormControl.touched }"
            aria-label="campaign-description-input"
          data-testid="campaign-description-input"></textarea>
          @if (CampaignDescriptionFormControl.touched && CampaignDescriptionFormControl.invalid) {
            <app-error-msg [errors]="CampaignDescriptionFormControl.errors"
              [fieldLabel]="'SEND_EMAIL.CAMPAIGN_DESCRIPTION_ERROR' | translate"
              data-testid="campaign-description-error" />
          }
        </div>

        <!-- Communication Category -->
        <div class="mb-3">
          <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="communication-category-label">{{ 'CAMPAIGN.COMMUNICATION_CATEGORY' | translate }}</label>
          <p-select
            formControlName="communication_category_id"
            [options]="communicationCategoryOptions"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            class="w-full text-sm"
            [placeholder]="'CAMPAIGN.COMMUNICATION_CATEGORY_PLACEHOLDER' | translate"
            [ngClass]="{ 'ng-invalid ng-dirty': CommunicationCategoryFormControl.invalid && CommunicationCategoryFormControl.touched }"
            aria-label="communication-category-dropdown"
            data-testid="communication-category-dropdown" />
          @if (CommunicationCategoryFormControl.touched && CommunicationCategoryFormControl.invalid) {
            <app-error-msg [errors]="CommunicationCategoryFormControl.errors"
              [fieldLabel]="'CAMPAIGN.COMMUNICATION_CATEGORY_REQUIRED' | translate"
              data-testid="communication-category-error" />
          }
        </div>

        @if (false) {
          <div>
            <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="tenant-selection-label">{{'CAMPAIGN.ADD_TENANTS' | translate }}</label>
            <p-treeSelect class="w-full text-sm"
              containerStyleClass="w-full text-sm"
              [options]="tenants"
              placeholder="Select..."
              formControlName="selected_tenant"
              selectionMode="checkbox"
              [filter]="true"
              [filterInputAutoFocus]="true"
              [ngClass]="{ 'ng-invalid ng-dirty': SelectedTenantsFormControl.invalid && SelectedTenantsFormControl.touched }"
              aria-label="tenant-selection-dropdown"
              data-testid="tenant-selection-dropdown" />
          </div>
        }
      </div>

      <!-- ═══════════════════════════════════════════════════════════
           ACTION GROUP 1 — outer container (future: multiple groups)
      ════════════════════════════════════════════════════════════ -->
      <div class="surface-0 shadow-2 border-round text-sm mt-3" data-testid="action-group-1">

        <!-- Action Group Header -->
        <div class="flex align-items-center justify-content-between py-2 px-3 surface-50 border-bottom-1 border-300 border-round-top"
          data-testid="action-group-1-header">
          <div class="flex align-items-center gap-2">
            <i class="pi pi-calendar text-primary text-sm"></i>
            <div>
              <span class="font-bold text-900 text-sm" data-testid="action-group-1-title">
                {{ 'CAMPAIGN.ADD_GROUP' | translate }}
              </span>
              <!-- Date + Time Slot inline in group header -->
              <span class="ml-3">
                <p-datepicker [showIcon]="true"
                  formControlName="campaign_action_date"
                  icon="fa fa-calendar font-light"
                  dateFormat="M dd,yy"
                  yearRange="2023:2030"
                  [placeholder]="'SEND_EMAIL.CHOOSE_DATE' | translate"
                  inputStyleClass="text-sm"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  [disabledDates]="disabledDates"
                  [ngClass]="{ 'ng-invalid ng-dirty': CampaignActionDateFormControl.invalid && CampaignActionDateFormControl.touched }"
                  (onSelect)="onDateChange($event)"
                  (click)="$event.stopPropagation()"
                  aria-label="campaign-action-date-input"
                  data-testid="campaign-action-date-input" />
              </span>
              @if (CampaignActionDateFormControl.value) {
                <span class="ml-2">
                  <p-select
                    [options]="timeSlotOptions"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="selectedTimeSlot()"
                    [ngModelOptions]="{standalone: true}"
                    (onChange)="selectedTimeSlot.set($event.value)"
                    (click)="$event.stopPropagation()"
                    [placeholder]="'CAMPAIGN.SCHEDULE_TIME_SLOT_PLACEHOLDER' | translate"
                    styleClass="text-sm"
                    appendTo="body"
                    aria-label="campaign-time-slot-select"
                    data-testid="campaign-time-slot-select" />
                </span>
              }
            </div>
          </div>
        </div>

        <!-- Steps container — indented inside the group -->
        <div class="px-3 pb-3">

        <!-- ─────────────────────────────────────────────────────────
             SECTION 1 — SEGMENTATION
        ──────────────────────────────────────────────────────────── -->
        <div class="surface-0 shadow-1 border-round text-sm mt-3" data-testid="segmentation-section">
        <!-- Section Header -->
        <div class="flex align-items-center justify-content-between py-2 px-3 cursor-pointer surface-100 border-round-top"
          (click)="showSegmentation=!showSegmentation"
          aria-label="toggle-segmentation-section"
          data-testid="toggle-segmentation-section">
          <div class="flex align-items-center gap-2">
            <div class="flex align-items-center justify-content-center w-2rem h-2rem border-round bg-primary text-white text-xs font-bold flex-shrink-0">
              1
            </div>
            <div>
              <div class="font-semibold text-900 text-sm" data-testid="segmentation-section-title">
                {{ 'CAMPAIGN.SECTION_SEGMENTATION' | translate }}
              </div>
              <div class="text-500 text-xs">{{ 'CAMPAIGN.SECTION_SEGMENTATION_SUBTITLE' | translate }}</div>
            </div>
          </div>
          <i class="fa text-600"
            [ngClass]="showSegmentation ? 'fa-chevron-up' : 'fa-chevron-down'"
            aria-label="toggle-segmentation-icon"
            data-testid="toggle-segmentation-icon"></i>
        </div>

        @if (showSegmentation) {
          <div>
            <div class="mb-1 p-3">
              <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.PRESET_CAMPAIGNS' | translate }}</label>
              <p-select
                [options]="campaignGroups"
                [(ngModel)]="selectedCampaign"
                [group]="true"
                [filter]="true"
                filterBy="label,category"
                [showClear]="true"
                [placeholder]="'CAMPAIGN.PLACE_HOLDER_PRESET_CAMPAIGNS' | translate"
                [filterPlaceholder]="'CAMPAIGN.PLACEHOLDER_SEARCH' | translate"
                styleClass="mt-2 w-full"
                panelStyleClass="w-full md:w-auto"
                [ngModelOptions]="{standalone: true}"
                (onClear)="clearCampaign()"
                (onChange)="onCampaignSelect($event)">
                <ng-template pTemplate="group" let-group>
                  <div class="flex align-items-center justify-content-between surface-100 py-2 px-3 mb-1 w-full">
                    <div class="flex align-items-center">
                      <i class="pi pi-tag mr-2 text-primary"></i>
                      <span class="font-semibold text-900">{{group.label}}</span>
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="item" let-item>
                  <div class="flex align-items-center w-full px-3 py-2">
                    <div class="flex flex-column w-full">
                      <span class="text-sm font-medium text-700 white-space-normal">{{item.label}}</span>
                      @if (item.description) {
                        <small class="text-xs text-500 white-space-normal">{{item.description}}</small>
                      }
                    </div>
                  </div>
                </ng-template>
              </p-select>
            </div>
            <div class="mb-3 p-3">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-rule-label">{{'CAMPAIGN.RULE' | translate }}</label>
              <query-builder [tenantId]="tenantId"
                [eventType]="eventType"
                (rule)="getRule($event)"
                [query]="sqlRule.value"
                aria-label="campaign-rule-builder"
                data-testid="campaign-rule-builder" />
            </div>
          </div>
        }
      </div>

        <!-- ─────────────────────────────────────────────────────────
             SECTION 2 — CLIENT FILTER
        ──────────────────────────────────────────────────────────── -->
        <div class="surface-0 shadow-1 border-round text-sm mt-3" data-testid="client-filter-card">
        <!-- Section Header -->
        <div class="flex align-items-center justify-content-between py-2 px-3 cursor-pointer surface-100 border-round-top"
          (click)="showClientFilter=!showClientFilter"
          aria-label="toggle-client-filter"
          data-testid="toggle-client-filter">
          <div class="flex align-items-center gap-2">
            <div class="flex align-items-center justify-content-center w-2rem h-2rem border-round bg-primary text-white text-xs font-bold flex-shrink-0">
              2
            </div>
            <div>
              <div class="font-semibold text-900 text-sm" data-testid="client-filter-section-title">
                {{ 'CAMPAIGN.SECTION_CLIENT_FILTER' | translate }}
              </div>
              <div class="text-500 text-xs">{{ 'CAMPAIGN.SECTION_CLIENT_FILTER_SUBTITLE' | translate }}</div>
            </div>
          </div>
          <i class="fa text-600"
            [ngClass]="showClientFilter ? 'fa-chevron-up' : 'fa-chevron-down'"
            aria-label="toggle-client-filter-icon"
            data-testid="toggle-client-filter-icon"></i>
        </div>

        @if (showClientFilter) {
          <app-client-filter
            (filterChange)="onClientFilterChange($event)"
            (validityChange)="onClientFilterValidityChange($event)"
            aria-label="client-filter-section"
            data-testid="client-filter-section" />
        }
      </div>

        <!-- ─────────────────────────────────────────────────────────
             SECTION 3 — ACTIONS
        ──────────────────────────────────────────────────────────── -->
        <div class="surface-0 shadow-1 border-round text-sm mt-3" data-testid="actions-section">
        <!-- Section Header (collapsible) -->
        <div class="flex align-items-center justify-content-between py-2 px-3 cursor-pointer surface-100 border-round-top"
          (click)="showActionsSection=!showActionsSection"
          aria-label="toggle-actions-section"
          data-testid="toggle-actions-section">
          <div class="flex align-items-center gap-2">
            <div class="flex align-items-center justify-content-center w-2rem h-2rem border-round bg-primary text-white text-xs font-bold flex-shrink-0">
              3
            </div>
            <div>
              <div class="font-semibold text-900 text-sm" data-testid="actions-section-title">
                {{ 'CAMPAIGN.SECTION_ACTIONS' | translate }}
              </div>
              <div class="text-500 text-xs">{{ 'CAMPAIGN.SECTION_ACTIONS_SUBTITLE' | translate }}</div>
            </div>
          </div>
          <i class="fa text-600"
            [ngClass]="showActionsSection ? 'fa-chevron-up' : 'fa-chevron-down'"
            aria-label="toggle-actions-section-icon"
            data-testid="toggle-actions-section-icon"></i>
        </div>

        @if (showActionsSection) {
          <div class="surface-100 p-3 border-top-1 border-300">
            <p-button
              icon="fa fa-chevron-down"
              label="Add Actions"
              iconPos="right"
              styleClass="text-sm"
              (click)="addActions.toggle($event)"
              aria-label="add-actions-button"
              data-testid="add-actions-button">
              <i class="fa fa-plus-circle mr-2"></i>
            </p-button>
            <p-popover #addActions styleClass="overflow-hidden right-0 text-sm w-12rem">
              <ng-template #content>
                <ul class="list-none -m-2 px-0 text-xs font-bold">
                  @for (action of Actions; track action) {
                    <li class="flex align-items-center my-1">
                      <p-checkbox checkboxIcon="fa fa-check"
                        [binary]="true"
                        [formControlName]="'selectedAction_'+action.key"
                        [value]="action.key"
                        [inputId]="action.key"
                        (onChange)="ToggleActions($event, action.key)"
                        [attr.aria-label]="'select-action-checkbox-' + action.key"
                        [attr.data-testid]="'select-action-checkbox-' + action.key" />
                      <label [for]="action.key" class="cursor-pointer ml-2" [attr.data-testid]="'action-label-' + action.key">{{ 'CAMPAIGN.TABLE.'+action.text | translate }}</label>
                    </li>
                  }
                </ul>
              </ng-template>
            </p-popover>
            <!-- Actions Table -->
            @if (showTable) {
              <div class="mt-3 surface-0 shadow-2 border-round mb-2">
                <p-table [value]="ActionTableData" responsiveLayout="scroll">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="text-xs text-600" data-testid="actions-column-header">{{'CAMPAIGN.ACTIONS' | translate }}</th>
                      <th class="text-xs text-600" data-testid="config-status-column-header">{{'CAMPAIGN.CONFIGURATION_STATUS' | translate }}</th>
                      <th class="text-xs text-600"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-tableData>
                    <tr class="text-sm">
                      <td class="py-2 relative white-space-nowrap border-left-3 border-{{tableData.color}} border-top-none px-0">
                        <div class="flex align-items-center text-{{tableData.color}} px-3" [attr.data-testid]="'action-name-' + tableData.key">
                          <i class="{{tableData.icon}} mr-2"></i>
                          <strong>{{ 'CAMPAIGN.TABLE.'+tableData.text | translate }}</strong>
                        </div>
                        <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0 absolute left-0 bottom-0 w-full" />
                      </td>
                      <td class="py-2 relative white-space-nowrap border-top-none px-0">
                        <div class="px-3" [attr.data-testid]="'action-status-' + tableData.key">{{tableData.status}}</div>
                        <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0 absolute left-0 bottom-0 w-full" />
                      </td>
                      <td class="py-2 relative white-space-nowrap border-top-none px-0 text-right">
                        <div class="px-3 flex align-items-center justify-content-end gap-2">
                          <p-button label="Configure"
                            icon="fa fa-gear"
                            styleClass="p-button-outlined text-sm hidden md:inline-block"
                            (click)="configureActions(tableData.key)"
                            [attr.aria-label]="'configure-action-' + tableData.key"
                            [attr.data-testid]="'configure-action-' + tableData.key" />
                          <p-button icon="fa fa-gear"
                            styleClass="p-button-outlined md:hidden"
                            (click)="configureActions(tableData.key)"
                            [attr.aria-label]="'configure-action-mobile-' + tableData.key"
                            [attr.data-testid]="'configure-action-mobile-' + tableData.key" />
                          <button
                            class="p-button p-button-text p-button-danger"
                            (click)="removeAction(tableData.key)"
                            [attr.aria-label]="'remove-action-' + tableData.key"
                            [attr.data-testid]="'remove-action-' + tableData.key">
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                        <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0 absolute left-0 bottom-0 w-full" />
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }
          </div>
        }
        </div><!-- /actions-section -->

        </div><!-- /steps container -->
      </div><!-- /action-group-1 -->

      <!-- Buttons -->
      <div class="flex align-items-center justify-content-between mt-3 pt-2">
        <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          (onClick)="CancelCampaign()"
          styleClass="p-button-text text-sm"
          aria-label="cancel-campaign-button"
          data-testid="cancel-campaign-button" />
        <p-button [label]="'CAMPAIGN.BTN_SAVE' | translate"
          [disabled]="!createCampaignForm.valid || !clientFilterValid"
          [loading]="btnLoading"
          (click)="CreateCampaign()"
          styleClass="text-sm"
          aria-label="save-campaign-button"
          data-testid="save-campaign-button" />
      </div>
    </form>
  </div>

  <!-- Child Components -->
  @if (showCreateOpportunityPopup) {
    <create-opportunity [visible]="showCreateOpportunityPopup" (onHide)="closeDialog()"  (onHide)="closeDialog()" 
      (hidePopup)="hideOpportunity($event)"
      aria-label="create-opportunity-popup"
      data-testid="create-opportunity-popup" />
  }

  @if (showBulkEmailPopup) {
    <send-bulk-email [visible]="showBulkEmailPopup" (onHide)="closeDialog()"  (onHide)="closeDialog()" 
      [tenantId]="tenantId"
      [EmailSendType]="EmailSendType"
      [CampaignSource]="campaignSource"
      [actionPayload]="getEmailActipnPayload"
      (hide)="HideSendEmail($event)"
      aria-label="send-bulk-email-popup"
      data-testid="send-bulk-email-popup" />
  }

  @if (showBulkSmsPopup) {
    <send-bulk-sms [visible]="showBulkSmsPopup" (onHide)="closeDialog()"  (onHide)="closeDialog()" 
      [tenantId]="tenantId"
      [SMSSendType]="SMSSendType"
      [CampaignSource]="campaignSource"
      [actionPayload]="getSmsActipnPayload"
      (hide)="HideSMSEmail($event)"
      aria-label="send-bulk-sms-popup"
      data-testid="send-bulk-sms-popup" />
  }

  @if (showBulkWhatsAppPopup) {
    <send-whatsapp [visible]="showBulkWhatsAppPopup" (onHide)="closeDialog()"  (onHide)="closeDialog()" 
      [tenantId]="tenantId"
      [WhatsAppSendType]="WhatsAppSendType"
      [CampaignSource]="campaignSource"
      [actionPayload]="getWhatsappActipnPayload"
      (hide)="HideWhatsAppPopup($event)"
      aria-label="send-whatsapp-popup"
      data-testid="send-whatsapp-popup" />
  }

  @if (showPushNotificationsPopup) {
    <send-push-notification [visible]="showPushNotificationsPopup" (onHide)="closeDialog()"  (onHide)="closeDialog()"  [tenantId]="tenantId"
      [pushNotificationSendType]="PushNotificationsSendType" [CampaignSource]="campaignSource"  [actionPayload]="getPushNotificationsActipnPayload"
      (hide)="hidePushNotificationsPopup($event)" />
  }

  @if (showTaskCreate) {
    <app-task-create [showPopup]="showTaskCreate" (onHide)="closeDialog()"  (onHide)="closeDialog()" 
      [taskCreateType]="taskCreateType"
      [CampaignSource]="campaignSource"
      [actionPayload]="getTaskActipnPayload"
      [automationMaster]="getSelectedAutomationType"
      [taskCreateformGroup]="formGroup"
      [uuid]="uuid"
      [mode]="mode"
      [scheduleInMin]="scheduleInMin"
      (HidePopup)="hideTaskCreate($event)"
      [notificationTo]="selectedNotificationTo"
       />
  }

  <!-- Amount Spender Modal -->
  @if (showAmountSpenderPopup) {
    <p-dialog [visible]="showAmountSpenderPopup" [resizable]="false" appendTo="body" [modal]="true" [closeOnEscape]="true"
      (onHide)="closeDialogEvent()" [breakpoints]="{'767px': '100vw'}" [style]="{width: '670px'}"
      styleClass="no-header-modal">
      <ng-template pTemplate="header" styleClass="hidden" />
      <ng-template pTemplate="content" styleClass="p-0">
        <!-- Header -->
        <div class="sticky left-0 top-0 z-1 surface-0 py-3 px-4 flex align-items-center justify-content-between border-bottom-1 border-300">
          <h2 class="mb-0 text-sm">{{'CAMPAIGN.HIGH_SPENDERS' | translate}}</h2>
          <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeDialogEvent()"></div>
        </div>
        <!-- Header -->
        <form [formGroup]="amountSpenderForm" (ngSubmit)="addAmountSpender()">
          <!-- Content -->
          <div class="py-3 px-4">
            <!-- Form Group -->
            <div class="mb-3">
              <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.AMOUNT_SPENDER' | translate}}</label>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{ currencySymbol$ | async }}</span>
                <p-inputNumber formControlName="amount" [min]="0" [max]="1000000" [step]="1000"
                  mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                  [showButtons]="false" styleClass="w-full" inputStyleClass="w-full text-sm"
                  [ngClass]="{ 'ng-invalid ng-dirty': AmountSpenderFormControl.invalid && AmountSpenderFormControl.touched }" />
              </div>
              @if (AmountSpenderFormControl.dirty && AmountSpenderFormControl.invalid) {
                <app-error-msg [errors]="AmountSpenderFormControl.errors" [fieldLabel]="'CAMPAIGN.AMOUNT_SPENDER' | translate" />
              }
            </div>
            <!-- Form Group -->
          </div>
          <!-- Content -->
          <!-- Modal Footer -->
          <div class="sticky left-0 bottom-0 z-1 surface-0 flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
            <p-button type="button" [label]="'CLIENT_PROFILE.KYE_FOB.CANCEL' | translate"
              styleClass="p-button-text text-sm" (click)="closeDialogEvent()" />
            <p-button type="submit" [label]="'CAMPAIGN.BTN_ADD' | translate"
              [loading]="btnLoading" [disabled]="amountSpenderForm.invalid" styleClass="text-sm" />
          </div>
          <!-- Modal Footer -->
        </form>
      </ng-template>
    </p-dialog>
  }
  <!-- Amount Spender Modal -->

